/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_EventInputs */

const th_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กิจกรรม`)
};

const en_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const ja_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント`)
};

const zh_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赛事`)
};

const es_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento`)
};

const pt_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento`)
};

const id_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara`)
};

const fr_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement`)
};

const tl_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const vi_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sự kiện`)
};

const ko_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트`)
};

const de_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const ru_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие`)
};

const tr_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik`)
};

const it_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento`)
};

const pl_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydarzenie`)
};

const uk_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подія`)
};

const hi_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन`)
};

const ar_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفعالية`)
};

const ms_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara`)
};

const bn_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজন`)
};

const zh_tw2_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽事`)
};

const zh_hk2_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽事`)
};

const ur_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایونٹ`)
};

const fa_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رویداد`)
};

const sw_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukio`)
};

const nl_nav_event = /** @type {(inputs: Nav_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement`)
};

/**
* | output |
* | --- |
* | "Event" |
*
* @param {Nav_EventInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const nav_event = /** @type {((inputs?: Nav_EventInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_EventInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_nav_event(inputs)
	if (locale === "ja") return ja_nav_event(inputs)
	if (locale === "zh") return zh_nav_event(inputs)
	if (locale === "es") return es_nav_event(inputs)
	if (locale === "pt") return pt_nav_event(inputs)
	if (locale === "id") return id_nav_event(inputs)
	if (locale === "fr") return fr_nav_event(inputs)
	if (locale === "tl") return tl_nav_event(inputs)
	if (locale === "vi") return vi_nav_event(inputs)
	if (locale === "ko") return ko_nav_event(inputs)
	if (locale === "de") return de_nav_event(inputs)
	if (locale === "ru") return ru_nav_event(inputs)
	if (locale === "tr") return tr_nav_event(inputs)
	if (locale === "it") return it_nav_event(inputs)
	if (locale === "pl") return pl_nav_event(inputs)
	if (locale === "uk") return uk_nav_event(inputs)
	if (locale === "hi") return hi_nav_event(inputs)
	if (locale === "ar") return ar_nav_event(inputs)
	if (locale === "ms") return ms_nav_event(inputs)
	if (locale === "bn") return bn_nav_event(inputs)
	if (locale === "zh-TW") return zh_tw2_nav_event(inputs)
	if (locale === "zh-HK") return zh_hk2_nav_event(inputs)
	if (locale === "ur") return ur_nav_event(inputs)
	if (locale === "fa") return fa_nav_event(inputs)
	if (locale === "sw") return sw_nav_event(inputs)
	if (locale === "nl") return nl_nav_event(inputs)
	return en_nav_event(inputs)
});